module.exports = __webpack_public_path__ + "img/unearth-malee_thumbnail.39e59061.jpg";